import { render, staticRenderFns } from "./SwitchTableSort.vue?vue&type=template&id=290a57dc&scoped=true&"
import script from "./SwitchTableSort.vue?vue&type=script&lang=js&"
export * from "./SwitchTableSort.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTableSort.vue?vue&type=style&index=0&id=290a57dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a57dc",
  null
  
)

export default component.exports